import React from 'react';
import './Aboutpage.css';
import '../scrollReveal.css';
import useScrollReveal from '../hooks/useScrollReveal';
import { FaShieldAlt, FaRocket, FaMedal, FaUsers } from 'react-icons/fa';

const values = [
  { icon: <FaRocket />, title: 'No Off-the-Shelf Parts', desc: "Every piece we make is custom. If you want a catalog part, we're not your shop. If you want something no one else has, you're in the right place." },
  { icon: <FaShieldAlt />, title: 'Exotic Cars Only', desc: "We specialize in Lamborghini, Ferrari, McLaren, Porsche, and other high-performance vehicles. We know these cars and we build parts that treat them with respect." },
  { icon: <FaMedal />, title: 'Precision Over Speed', desc: "We don't rush builds. Every part is scanned, modeled, and quality-checked before it ships. Fitment matters to us as much as it matters to you." },
  { icon: <FaUsers />, title: 'Direct Line to the Builder', desc: "You work directly with the team building your parts — not a sales rep. Real answers, fast communication, and no runaround." },
];

const stats = [
  { num: '100+', label: 'Custom Builds Delivered' },
  { num: '±0.1mm', label: 'Print Tolerance' },
  { num: '24hr', label: 'Quote Turnaround' },
  { num: '5★', label: 'Client Satisfaction' },
];

const AboutPage = () => {
  const heroRef = useScrollReveal();
  const statsRef = useScrollReveal();
  const missionRef = useScrollReveal();
  const valuesRef = useScrollReveal();
  const ctaRef = useScrollReveal();

  return (
    <div className="about-page">
      <section className="about-hero" ref={heroRef}>
        <div className="about-hero-bg" />
        <div className="about-hero-grid" />
        <div className="about-hero-corner tl" />
        <div className="about-hero-corner tr" />
        <div className="about-hero-corner bl" />
        <div className="about-hero-corner br" />
        <div className="about-hero-content">
          <div className="about-eyebrow" data-reveal="fade-down">Who We Are</div>
          <h1 data-reveal="fade-up" data-delay="150">Built for Car People,<br /><span className="about-highlight">By Car People.</span></h1>
          <p data-reveal="fade-up" data-delay="300">
            KING3DMFG is a precision fabrication studio specializing in custom carbon fiber aero, one-off body components, and 3D-printed upgrades for exotic and hypercar owners who demand more than what the aftermarket offers.
          </p>
        </div>
      </section>

      <section className="about-stats-section" ref={statsRef}>
        <div className="about-stats-grid">
          {stats.map((s, i) => (
            <div key={i} className="about-stat-card" data-reveal="fade-up" data-delay={String(100 + i * 100)}>
              <span className="about-stat-num">{s.num}</span>
              <span className="about-stat-label">{s.label}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="about-mission" ref={missionRef}>
        <div className="about-mission-inner">
          <div className="about-section-eyebrow" data-reveal="fade-right">Our Mission</div>
          <h2 data-reveal="fade-up" data-delay="100">We Build What Doesn't Exist Yet</h2>
          <p data-reveal="fade-up" data-delay="200">
            The exotic car aftermarket is full of mass-produced parts designed to fit a hundred different cars "close enough." We don't believe in close enough. Every part we build is engineered to fit your exact vehicle — scanned, modeled, and fabricated with tolerances that OEM manufacturers would respect.
          </p>
          <p data-reveal="fade-up" data-delay="300">
            We work with owners, collectors, and build shops who are done settling for what exists and want something nobody else has. Whether that's a full carbon aero kit for a Lamborghini Huracán or a custom intake for a McLaren 720S, we bring engineering precision to the world of bespoke automotive builds.
          </p>
        </div>
      </section>

      <section className="about-values" ref={valuesRef}>
        <div className="about-values-container">
          <div className="about-section-eyebrow center" data-reveal="fade-down">Core Values</div>
          <h2 className="about-section-title center" data-reveal="fade-up" data-delay="100">How We Work</h2>
          <div className="about-values-grid">
            {values.map((v, i) => (
              <div key={i} className="about-value-card" data-reveal="flip" data-delay={String(150 + i * 150)}>
                <span className="about-value-icon">{v.icon}</span>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-cta" ref={ctaRef}>
        <div className="about-cta-inner">
          <div className="about-section-eyebrow center" data-reveal="fade-down">Let's Work Together</div>
          <h2 data-reveal="zoom" data-delay="100">Have a Build in Mind?</h2>
          <p data-reveal="fade-up" data-delay="200">Tell us about your car and what you're looking to create. We respond to every inquiry within 24 hours.</p>
          <button className="about-cta-btn" data-reveal="fade-up" data-delay="300"
            onClick={() => { window.location.href = '/#quote-form'; }}>
            Start Your Build
          </button>
        </div>
      </section>

      <footer className="about-footer">
        &copy; {new Date().getFullYear()} KING3DMFG — All Rights Reserved
      </footer>
    </div>
  );
};

export default AboutPage;
